import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import ILieuSejour from "../../models/ILieuSejour";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestionLieuxSejourProps {
  isModeSelection?: boolean,
}

export default function GestionLieuxSejour({ isModeSelection }: IGestionLieuxSejourProps) {
  const clientFormDataSource = useCustomDataSource<ILieuSejour, ILieuSejour>({ path: "lieuSejour", primaryKey: "idLieuSejour" });
  const { selectedDataRow: selectedLieuSejour, mode, setMode, isFieldModifier, setIsFieldModifier, onFieldDataChanged } = clientFormDataSource;
  const { setSelectedValue } = useContextPopupPage();

  const actifOptions = useMemo(() => {
    return { text: "Actif" };
  }, []);
  const disponibleEnLigneOptions = useMemo(() => {
    return { text: "Disponible en ligne" };
  }, []);

  return (
    <FormListBase data={clientFormDataSource}>
      <FormListBaseGrid dataSource={clientFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture)
          }
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}
      >
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`Groupe#${selectedLieuSejour?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture ? <FormListBaseTab>
        <TabItem title="Informations">
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedLieuSejour || {} as ILieuSejour} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
            <SimpleItem key={"frm-description"} dataField={"description"} />
            <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
              editorOptions={
                actifOptions
              }
            >
              <Label visible={false} />
            </SimpleItem>
          </Form>
        </TabItem>
        <TabItem title="Internet">
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedLieuSejour || {} as ILieuSejour} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
            <SimpleItem key={"frm-disponible-en-ligne"} dataField={"disponibleEnLigne"} editorType={"dxCheckBox"}
              editorOptions={
                disponibleEnLigneOptions
              }
            >
              <Label visible={false} />
            </SimpleItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedLieuSejour || {} as ILieuSejour} /></TabItem>
      </FormListBaseTab> : null}
    </FormListBase>
  );
}